<template>
  <template v-if="containers.length > 0">
    <div class="grid grid-cols-4 gap-6">
      <div>
        <nav class="space-y-1" :aria-label="$t('Sidebar')">
          <Link v-for="(container, idx) in containers" :key="container.name" :href="container.show_url"
                :class="[isActiveContainer(container.id) ? 'bg-secondary-100 text-white' : 'text-secondary-600 hover:bg-secondary-50 hover:text-white', 'group flex items-center px-3 py-2 text font-medium rounded-md']"
                :aria-current="isActiveContainer(container.id) ? 'page' : undefined">
                        <span class="truncate">
                            {{ container.name }}
                        </span>
            <span v-if="($page.props.auth.user.is_superuser || !container.can_mutate) && container.unread_files.length > 0"
                  :class="[isActiveContainer(container.id) ? 'bg-white text-secondary-600' : 'bg-gray-200 text-gray-600 group-hover:bg-gray-200', 'ml-auto inline-block py-0.5 px-3 text-sm rounded-full']">
                            {{ container.unread_files.length }}
                        </span>
          </Link>
        </nav>
      </div>
      <div class="col-span-3">
        <file-container :container="activeContainer"
                        :mutation-disabled="!activeContainer.can_mutate"></file-container>
        <!--                <div :key="container.id"
                             v-for="(container, idx) in containers"
                             v-show="isActiveContainer(container.id, idx)">
                            <file-container :container="container"
                                            :mutation-disabled="!container.can_mutate"></file-container>
                        </div>-->
      </div>
    </div>
    <!--        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
                <div :key="container.id"
                     v-for="container in containers">
                    <file-container :container="container"
                                    :mutation-disabled="!container.can_mutate"></file-container>
                </div>
            </div>-->
  </template>
  <template v-else>
    <div class="shadow-md rounded-lg bg-white text-center text-warning-400 py-5">
      {{ $t('Currently no file storage areas are available for your account.') }}
    </div>
  </template>
</template>

<script>
import {defineComponent} from 'vue'
import {Link} from '@inertiajs/vue3';
import FileContainer from '@/Components/FileContainer.vue'

export default defineComponent({
  components: {
    FileContainer,
    Link,
  },

  data() {
    return {
      activeContainerId: null,
    }
  },

  props: {
    containers: Object,
    activeContainer: Object,
  },

  methods: {
    isActiveContainer(containerId) {
      return this.activeContainer.id == containerId;
    },
  }
})
</script>
